<script>
    import PortalCustomFontFamily from "./components/PortalCustomFontFamily.svelte";
    import PortalCustomForm from "./components/PortalCustomForm.svelte";
    import PortalCustomHeader from "./components/PortalCustomHeader.svelte";

    export let fontFamilyConfig = {},
        topHeaderConfig = {},
        formConfig = {},
        editorRef;
</script>

<div class="flex flex-col flex-1 gap-y-4 p-2 overflow-y-auto">
    <div class="flex flex-col gap-y-2">
        <p class="text-lg font-bold">General Config:</p>

        <div class="flex flex-col gap-y-2">
            <PortalCustomFontFamily bind:fontFamilyConfig />
        </div>
    </div>

    <PortalCustomHeader bind:editorRef bind:topHeaderConfig />

    <PortalCustomForm bind:formConfig />
</div>
